"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { getCopiedDropLink } from "@/helpers/waves/drop-copy-link.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import type { FC } from "react";
import { useContext, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropMobileMenuBoost from "./WaveDropMobileMenuBoost";
import WaveDropMobileMenuDelete from "./WaveDropMobileMenuDelete";
import WaveDropMobileMenuEdit from "./WaveDropMobileMenuEdit";
import WaveDropMobileMenuSetPinnedDrop from "./WaveDropMobileMenuSetPinnedDrop";
import WaveDropMobileMenuOpen from "./WaveDropMobileMenuOpen";
import WaveDropActionsQuickReact from "./WaveDropActionsQuickReact";
interface WaveDropMobileMenuProps {
  readonly drop: ApiDrop;
  readonly isOpen: boolean;
  readonly showReplyAndQuote: boolean;
  readonly longPressTriggered: boolean;
  readonly setOpen: (open: boolean) => void;
  readonly onReply: () => void;
  readonly onAddReaction: () => void;
  readonly onEdit?: (() => void) | undefined;
  readonly onBoostAnimation?: (() => void) | undefined;
  readonly showOpenOption?: boolean | undefined;
  readonly showCopyOption?: boolean | undefined;
}
const WaveDropMobileMenu: FC<WaveDropMobileMenuProps> = t0 => {
  const $ = _c(41);
  const {
    drop,
    isOpen,
    showReplyAndQuote,
    longPressTriggered,
    setOpen,
    onReply,
    onAddReaction,
    onEdit,
    onBoostAnimation,
    showOpenOption: t1,
    showCopyOption: t2
  } = t0;
  const showOpenOption = t1 === undefined ? true : t1;
  const showCopyOption = t2 === undefined ? true : t2;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const {
    isMemesWave
  } = useSeizeSettings();
  let t3;
  if ($[0] !== drop.id) {
    t3 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isTemporaryDrop = t3;
  const {
    canDelete,
    canSetPinnedDrop
  } = useDropInteractionRules(drop);
  let t4;
  if ($[2] !== drop) {
    t4 = {
      ...drop,
      type: DropSize.FULL,
      stableKey: drop.id,
      stableHash: drop.id
    };
    $[2] = drop;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const extendedDrop = t4;
  const [copied, setCopied] = useState(false);
  let closeMenu;
  let copyToClipboard;
  let isAuthor;
  let showOptions;
  if ($[4] !== activeProfileProxy || $[5] !== connectedProfile || $[6] !== drop || $[7] !== isMemesWave || $[8] !== isTemporaryDrop || $[9] !== setOpen) {
    copyToClipboard = () => {
      if (isTemporaryDrop) {
        return;
      }
      const waveDetails = drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      };
      const isDirectMessage = waveDetails.chat?.scope?.group?.is_direct_message ?? false;
      const dropLink = getCopiedDropLink({
        drop,
        isDirectMessage,
        isMemesWave
      });
      if (typeof navigator.clipboard.writeText === "function") {
        navigator.clipboard.writeText(dropLink).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = dropLink;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
      closeMenu();
    };
    isAuthor = connectedProfile?.handle === drop.author.handle && !activeProfileProxy;
    let t5;
    bb0: {
      if (!connectedProfile?.handle) {
        t5 = false;
        break bb0;
      }
      if (activeProfileProxy) {
        t5 = false;
        break bb0;
      }
      if (drop.id.startsWith("temp-")) {
        t5 = false;
        break bb0;
      }
      t5 = connectedProfile.handle === drop.author.handle;
    }
    showOptions = t5;
    closeMenu = () => setOpen(false);
    $[4] = activeProfileProxy;
    $[5] = connectedProfile;
    $[6] = drop;
    $[7] = isMemesWave;
    $[8] = isTemporaryDrop;
    $[9] = setOpen;
    $[10] = closeMenu;
    $[11] = copyToClipboard;
    $[12] = isAuthor;
    $[13] = showOptions;
  } else {
    closeMenu = $[10];
    copyToClipboard = $[11];
    isAuthor = $[12];
    showOptions = $[13];
  }
  const showGuestCopyOnly = !connectedProfile?.handle;
  const t5 = `tw-grid tw-grid-cols-1 ${longPressTriggered && "tw-select-none"}`;
  let t6;
  if ($[14] !== canDelete || $[15] !== canSetPinnedDrop || $[16] !== closeMenu || $[17] !== copied || $[18] !== copyToClipboard || $[19] !== drop || $[20] !== extendedDrop || $[21] !== isAuthor || $[22] !== isTemporaryDrop || $[23] !== onAddReaction || $[24] !== onBoostAnimation || $[25] !== onEdit || $[26] !== onReply || $[27] !== setOpen || $[28] !== showCopyOption || $[29] !== showGuestCopyOnly || $[30] !== showOpenOption || $[31] !== showOptions || $[32] !== showReplyAndQuote) {
    t6 = showGuestCopyOnly ? showCopyOption && <button className={`tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${isTemporaryDrop ? "tw-cursor-default tw-opacity-50" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={copyToClipboard} disabled={isTemporaryDrop}><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" /></svg><span className={`tw-text-base tw-font-semibold ${copied ? "tw-text-primary-400" : "tw-text-iron-300"}`}>{copied ? "Copied!" : "Copy link"}</span></button> : <><WaveDropActionsQuickReact drop={extendedDrop} isMobile={true} onReacted={closeMenu} /><WaveDropActionsAddReaction drop={extendedDrop} isMobile={true} onAddReaction={onAddReaction} />{showReplyAndQuote && <button className={`tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${isTemporaryDrop ? "tw-cursor-default tw-opacity-50" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={() => {
        setOpen(false);
        setTimeout(() => onReply(), 250);
      }} disabled={isTemporaryDrop}><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M7.49 12L3.74 8.248m0 0l3.75-3.75m-3.75 3.75h16.5V19.5" /></svg><span className="tw-text-base tw-font-semibold tw-text-iron-300">Reply</span></button>}<WaveDropMobileMenuBoost drop={extendedDrop} onBoostChange={closeMenu} onBoostAnimation={onBoostAnimation} />{showOpenOption && <WaveDropMobileMenuOpen drop={{
        type: DropSize.FULL,
        ...drop,
        stableHash: drop.id,
        stableKey: drop.id
      }} onOpenChange={closeMenu} />}{showCopyOption && <button className={`tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${isTemporaryDrop ? "tw-cursor-default tw-opacity-50" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`} onClick={copyToClipboard} disabled={isTemporaryDrop}><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" /></svg><span className={`tw-text-base tw-font-semibold ${copied ? "tw-text-primary-400" : "tw-text-iron-300"}`}>{copied ? "Copied!" : "Copy link"}</span></button>}<WaveDropActionsMarkUnread drop={drop} isMobile={true} onMarkUnread={closeMenu} />{!isAuthor && <WaveDropActionsRate drop={drop} isMobile={true} onRated={closeMenu} />}{showOptions && onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropMobileMenuEdit drop={drop} onEdit={onEdit} onEditTriggered={closeMenu} />}{canSetPinnedDrop && <WaveDropMobileMenuSetPinnedDrop drop={drop} onPinnedDropSet={closeMenu} />}{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={closeMenu} />}</>;
    $[14] = canDelete;
    $[15] = canSetPinnedDrop;
    $[16] = closeMenu;
    $[17] = copied;
    $[18] = copyToClipboard;
    $[19] = drop;
    $[20] = extendedDrop;
    $[21] = isAuthor;
    $[22] = isTemporaryDrop;
    $[23] = onAddReaction;
    $[24] = onBoostAnimation;
    $[25] = onEdit;
    $[26] = onReply;
    $[27] = setOpen;
    $[28] = showCopyOption;
    $[29] = showGuestCopyOnly;
    $[30] = showOpenOption;
    $[31] = showOptions;
    $[32] = showReplyAndQuote;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  let t7;
  if ($[34] !== t5 || $[35] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[34] = t5;
    $[35] = t6;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  let t8;
  if ($[37] !== isOpen || $[38] !== setOpen || $[39] !== t7) {
    t8 = createPortal(<CommonDropdownItemsMobileWrapper isOpen={isOpen} setOpen={setOpen}>{t7}</CommonDropdownItemsMobileWrapper>, document.body);
    $[37] = isOpen;
    $[38] = setOpen;
    $[39] = t7;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  return t8;
};
export default WaveDropMobileMenu;